export const knmErpMapStatusNameByNewName: Record<string, string> = {
  Новое: 'В процессе формирования',
  'Ожидает согласования': 'В процессе формирования',
  'Требует доработки': 'В процессе формирования',
  Отклонено: 'Отклонено',
  'Ожидает проведения': 'В процессе проведения',
  'Ожидает завершения': 'В процессе проведения',
  Завершено: 'Завершено',
  'Не может быть проведено': 'Удалено',
  Обжаловано: 'Завершено',
  Удалено: 'Удалено',
};
